module.exports = __webpack_public_path__ + "img/1_2025_04_15.3f6dd95f.jpg";